(() => {
  'use strict';

  if (window.__blzPlpCardsBraeLoaded) return;
  window.__blzPlpCardsBraeLoaded = true;

  const parseSection = (html, selector) => {
    if (!html) return null;

    const parser = new DOMParser();
    const parsed = parser.parseFromString(html, 'text/html');
    return parsed.querySelector(selector);
  };

  const updateCartBubble = (sections) => {
    if (!sections || !sections['cart-icon-bubble']) return;

    const currentBubble = document.getElementById('cart-icon-bubble');
    const incomingBubble = parseSection(
      sections['cart-icon-bubble'],
      '#cart-icon-bubble'
    );

    if (currentBubble && incomingBubble) {
      currentBubble.innerHTML = incomingBubble.innerHTML;
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.blz-plp-card__form');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('[data-blz-plp-add-button]');
    const label = form.querySelector('[data-blz-plp-add-label]');

    if (!button || button.disabled) return;

    const defaultText = button.dataset.defaultText || 'Comprar Agora';

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.remove('is-added', 'has-error');

    if (label) label.textContent = 'Adicionando...';

    try {
      const formData = new FormData(form);
      const cartDrawer = document.querySelector('cart-drawer');

      if (
        cartDrawer &&
        typeof cartDrawer.getSectionsToRender === 'function'
      ) {
        const sections = cartDrawer
          .getSectionsToRender()
          .map((section) => section.id)
          .filter(Boolean);

        if (sections.length) {
          formData.append('sections', sections.join(','));
        }
      } else {
        formData.append('sections', 'cart-icon-bubble');
      }

      formData.append('sections_url', window.location.pathname);

      const response = await fetch(
        window.routes?.cart_add_url || '/cart/add.js',
        {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          },
          body: formData
        }
      );

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(
          data.description ||
          data.message ||
          'Não foi possível adicionar o produto.'
        );
      }

      if (
        cartDrawer &&
        typeof cartDrawer.renderContents === 'function'
      ) {
        cartDrawer.renderContents(data);
      } else {
        updateCartBubble(data.sections);
      }

      document.dispatchEvent(
        new CustomEvent('blz:cart-added', {
          detail: data
        })
      );

      if (label) label.textContent = 'Adicionado ✓';
      button.classList.add('is-added');

      window.setTimeout(() => {
        if (label) label.textContent = defaultText;
        button.classList.remove('is-added');
      }, 1600);
    } catch (error) {
      console.error(
        '[BLZ PLP] Erro ao adicionar ao carrinho:',
        error
      );

      if (label) label.textContent = 'Tentar novamente';
      button.classList.add('has-error');

      window.setTimeout(() => {
        if (label) label.textContent = defaultText;
        button.classList.remove('has-error');
      }, 2200);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();